import { get } from 'axios';
import appConfig from 'src/utils/appConfig';

const getURL = (learningLanguages) => {
  const { locale, apigatewayBaseUrl } = appConfig.getMyConfig();
  const pathToFlow = learningLanguages[appConfig.getLearningLanguage()][locale];
  return `${apigatewayBaseUrl}/v1.0.0/${pathToFlow}`;
};

export default (learningLanguages) =>
  get(getURL(learningLanguages))
    .then((response) => response.data.lesson);
